export const CheckMark = (props) => (<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" {...props}>
        <path d="M384.064 640.213333 213.482667 469.568 128.192 554.88 298.773333 725.525333 384.064 810.858667 895.850667 298.922667 810.56 213.589333 384.064 640.213333Z" fill="currentColor"></path>
    </svg>);
